<template>
  <!-- DOWNLOAD XML -->
  <div id="tst">
    <a id="dLinkXml">
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          :disabled="desabilitar"
          :class="[desabilitar ? 'c_disabled' : '']"
          color="light-blue darken-4"
          icon
          small
          flat
          @click="setXml()"
        >
          <svg class="customIcon i_action" viewBox="0 0 24 24">
            <path
              fill="#000000"
              d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M6.12,15.5L9.86,19.24L11.28,17.83L8.95,15.5L11.28,13.17L9.86,11.76L6.12,15.5M17.28,15.5L13.54,11.76L12.12,13.17L14.45,15.5L12.12,17.83L13.54,19.24L17.28,15.5Z"
            />
          </svg>
        </v-btn>
        <span>
          Baixar
          <span v-if="component.name.indexOf('NFe') != -1">XML</span>
          <span
            v-else-if="desabilitar"
          >XML ainda não está disponível, Motor Fiscal está trabalhando nisso!</span>
          <span v-else>XML</span>
          </span>
      </v-tooltip>
    </a>
  </div>
</template>
<script>
import NfeService from "@/domain/notas/nfe/NfeService";
import CteService from "@/domain/notas/cte/CteService";
import NfseService from "@/domain/notas/nfse/NfseService";
export default {
  props: ["nota", "component"],
  data: () => ({
    xml: ""
  }),
  updated: function() {
    this.$nextTick(function() {});
  },
  computed: {
    desabilitar: function() {

      if(this.component.name.toLowerCase().indexOf("nfse") != -1 ) {
        if(this.nota.item.gzipPath !== undefined){
          return false
        }else{
          return true
        }
       
      }
      //caso não ter o gzipPath bloquear recebidas
      if(this.component.name.toLowerCase().indexOf("nfe") != -1) {
        if(this.nota.item.docZip !== undefined && this.nota.item.docZip.length) {
          return false;
        }else {
          return true;
        }
      }
    }
  },
  methods: {
    setXml: async function() {
      if (this.component.name.indexOf("NFe") != -1) {
        this.service = new NfeService(this.$http);
      } else if (this.component.name == "CTE") {
        this.service = new CteService(this.$http);
      } else if (this.component.name == "NFSE") {
        this.service = new NfseService(this.$http);
      }

      await this.service.getXml(this.nota.item._id).then(xml => {
        this.xml = xml;
      });
      this.setDownload();
    },
    setDownload: function() {
      let nome =
        this.component.name != "NFSE"
          ? this.nota.item.chave
          : `${this.nota.item.cnpjCpf}_${this.nota.item.numeroNfe}`;
      var a = document.querySelector("#dLinkXml");
      a.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(this.xml)
      );
      a.setAttribute("download", nome + ".xml");
      a.click();
      a.removeAttribute("href");
      a.removeAttribute("download");

      // :href="'data:application/pdf;base64,'+ encodeURIComponent(this.nota.item.danfe)" :download="this.nota.item.chave+'.pdf'"
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnDownload/btnXml/BtnXml.vue